<div class="card">
    <div class="card-title">{{cardTitle}}</div>
    <p>{{cardDescription}}</p>
    <div class="card-link" *ngIf="cardLink">
        <a (click)="irPara(cardLink)">Saiba Mais</a>
    </div>
</div>